import axiosInstance from './../axiosInstance';
import { buildParams } from '../buildParams';

/**
 * Get single email.
 *
 * @param {int} partnerEmailId
 */
export const getEmail = partnerEmailId => {
  const url = `partnerEmails/${partnerEmailId}`;
  return axiosInstance.get(url);
};

/**
 * Get emails.
 * @param {uuid} eventID
 * @param {uuid} partnerID
 * @param {object} params
 */
export const getEmails = (eventID, partnerID,  params) => {
    const url = `events/${eventID}/partners/${partnerID}/partnerEmails`;
    return axiosInstance.get(url, {params: buildParams(params)}).then(
      response => {
        // Filter out template from emails.
        response.data.data.partnerEmails = response.data.data.partnerEmails.filter(email => email.partnerID !== null);
        
        return response;
      }
    );
};

/**
 * Get emails.
 * @param {uuid} eventID
 * @param {uuid} partnerID
 */
export const getEmailTemplate = (eventID, partnerID) => {
  const url = `events/${eventID}/partners/${partnerID}/partnerEmails`;
  const params = {
    filter: [{
    column: 'partnerID',
    condition: 'null',
    values: []
  }]}
  return axiosInstance.get(url, {params: params}).then(
    response => {
      // Filter out template from emails.
      response.data.data.templateEmail = response.data.data.partnerEmails.filter(email => email.partnerID == null)[0];
      
      return response;
    }
  );
};

/**
 * Save email information.
 *
 * @param {object} values
 */
export const saveEmail = (values) => {
  let url = 'partnerEmails';
  if(values.partnerEmailId) {
    url += `/${values.partnerEmailId}`;
  }
  return axiosInstance.post(url, values);
};

/**
 * Send email.
 *
 * @param {int} partnerEmailId
 */
export const sendEmail = partnerEmailId => {
    return axiosInstance.post(`partnerEmails/${partnerEmailId}/send`);
};

/**
 * Send email test.
 *
 * @param {int} partnerEmailId
 * @param {object} emails
 */
export const sendTestEmail = (partnerEmailId, emails) => {
    return axiosInstance.post(`partnerEmails/${partnerEmailId}/testSend`, emails);
};

/**
 * Get email related meta
 */
export const getEmailMeta = () => {
  return axiosInstance.get('partnerEmails/meta');
};

/**
 * Get email preview
 */
export const getEmailPreview = (partnerEmailId) => {
  return axiosInstance.get(`partnerEmails/${partnerEmailId}/preview`);
};